import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import moment from "moment";
import {
  Grid,
  Dialog,
  Button,
  IconButton,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import NumberFormat from "react-number-format";
import { toast } from "react-toastify";

import "./modalDatosIniciales.css";

import {
  iniUpdateBudget,
  budgetsUpdateDatosInicialesNotSave,
} from "../../../redux/actions/pptosGastos";

export const PptosFormModalDatosIniciales = ({ open, handleClose }) => {
  const dispatch = useDispatch();

  const infoGeneral = useSelector((state) => state.general);
  const { currencyList } = infoGeneral;
  const { local_simbolo, local_separacion_miles, local_separacion_decimales } =
    infoGeneral.info;

  const detailBudget = useSelector((state) => state.pptoGasto.detail);
  const {
    referencia,
    id_moneda,
    moneda,
    fecha_asignacion_ini,
    fecha_asignacion_fin,
    in_flow,
    valor_tipo_cambio,
    temporalidad,
    total_asignado,
  } = detailBudget;

  const [form, setForm] = useState({
    referencia: referencia,
    id_moneda: id_moneda,
    moneda: moneda,
    fecha_asignacion_ini: fecha_asignacion_ini,
    fecha_asignacion_fin: fecha_asignacion_fin,
    in_flow: in_flow,
    valor_tipo_cambio: valor_tipo_cambio,
    temporalidad: temporalidad,
    total_asignado: total_asignado,
  });

  const handleChange = ({ target }) => {
    setForm({
      ...form,
      [target.name]: target.value,
    });
  };

  const handleChangeTipoCambio = (value) => {
    setForm({
      ...form,
      valor_tipo_cambio: value.floatValue,
    });
  };

  const handleChangeTotalAsignado = (value) => {
    setForm({
      ...form,
      total_asignado: value.floatValue,
    });
  };

  const handleChangeTemporalidad = ({ target }) => {
    const newTemporalidad = target.value;

    if (newTemporalidad === "anual") {
      const fechaIni = moment(new Date()).startOf("month").format("YYYY-MM-DD");
      const fechaFin = moment(fechaIni).add(11, "months").format("YYYY-MM-DD");

      setForm({
        ...form,
        temporalidad: newTemporalidad,
        fecha_asignacion_ini: fechaIni,
        fecha_asignacion_fin: fechaFin,
      });
    } else {
      if (newTemporalidad === "mensual") {
        setForm({
          ...form,
          temporalidad: newTemporalidad,
        });
      } else {
        const fechaIni = moment(new Date())
          .startOf("month")
          .format("YYYY-MM-DD");
        const fechaFin = moment(fechaIni).add(2, "months").format("YYYY-MM-DD");

        setForm({
          ...form,
          temporalidad: newTemporalidad,
          fecha_asignacion_ini: fechaIni,
          fecha_asignacion_fin: fechaFin,
        });
      }
    }
  };

  const handleChangeDateIni = (newValue) => {
    const newDate = moment(new Date(newValue)).format("YYYY-MM-DD");

    if (form.temporalidad === "anual") {
      const fechaIni = moment(newDate).startOf("month").format("YYYY-MM-DD");
      const fechaFin = moment(fechaIni).add(11, "months").format("YYYY-MM-DD");

      setForm({
        ...form,
        fecha_asignacion_ini: fechaIni,
        fecha_asignacion_fin: fechaFin,
      });
    } else {
      setForm({
        ...form,
        fecha_asignacion_ini: newValue,
      });
    }
  };

  const handleChangeDateFin = (newValue) => {
    setForm({
      ...form,
      fecha_asignacion_fin: newValue,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newDetail = {
      ...detailBudget,
      referencia: form.referencia,
      id_moneda: form.id_moneda,
      moneda: form.moneda,
      fecha_asignacion_ini: form.fecha_asignacion_ini,
      fecha_asignacion_fin: form.fecha_asignacion_fin,
      in_flow: form.in_flow,
      valor_tipo_cambio: form.valor_tipo_cambio,
      temporalidad: form.temporalidad,
      total_asignado: form.total_asignado,
    };

    if (newDetail.id > 0) {
      dispatch(iniUpdateBudget(newDetail));
    } else {
      dispatch(budgetsUpdateDatosInicialesNotSave(newDetail));
      toast.success("presupuesto actualizado");
    }
  };

  const handleChangeAddFlow = ({ target }) => {
    setForm({
      ...form,
      in_flow: target.checked,
    });
  };

  return (
    <Dialog
      className="dialogoCrearPresupuesto"
      open={open}
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
    >
      <div className="ContainerDialogs">
        <h1 className="TitleModalPresupuesto">
          {"Información inicial"}
          <IconButton
            style={{ padding: "0", float: "right" }}
            aria-label="close"
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
        </h1>
        <form onSubmit={handleSubmit} style={{ marginTop: "30px" }}>
          <Grid container>
            <Grid item xs={12}>
              <Grid
                container
                spacing="20"
                columnSpacing="16"
                alignItems="center"
                direction="row"
              >
                <Grid item xs={12}>
                  <TextField
                    className="p-box-referencia"
                    label="Nombre o referencia"
                    name="referencia"
                    id="outlined-size-small"
                    value={form.referencia || ""}
                    size="small"
                    fullWidth
                    placeholder="Ingrese nombre de lo que estás presupuestando"
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">
                      Tiempo
                    </InputLabel>
                    <Select
                      label="Tiempo"
                      id="temporalidad"
                      name="temporalidad"
                      value={form.temporalidad || ""}
                      onChange={handleChangeTemporalidad}
                      style={{ textTransform: "uppercase" }}
                    >
                      <MenuItem value="" key="">
                        Ninguno
                      </MenuItem>
                      <MenuItem value="mensual" key="mensual">
                        Mensual
                      </MenuItem>
                      <MenuItem value="anual" key="anual">
                        Anual
                      </MenuItem>
                      <MenuItem value="otro" key="anual">
                        Otro
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <div className="p-container-date">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DesktopDatePicker
                        views={["year", "month"]}
                        label={
                          form.temporalidad === "mensual"
                            ? "Mes presupuesto"
                            : "Fecha inicio"
                        }
                        openTo="month"
                        inputFormat="DD/MM/YYYY"
                        name="fecha_asignacion_ini"
                        value={form.fecha_asignacion_ini}
                        onChange={handleChangeDateIni}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </div>
                </Grid>

                {form.temporalidad !== "mensual" ? (
                  <Grid item xs={12} sm={6}>
                    <div className="p-container-date">
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                          views={["year", "month"]}
                          label="Fecha fin"
                          openTo="month"
                          inputFormat="DD/MM/YYYY"
                          name="fecha_asignacion_fin"
                          value={form.fecha_asignacion_fin}
                          onChange={(value) =>
                            handleChangeDateFin(value, "fecha_asignacion_fin")
                          }
                          renderInput={(params) => <TextField {...params} />}
                        />
                      </LocalizationProvider>
                    </div>
                  </Grid>
                ) : (
                  ""
                )}

                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">
                      Moneda
                    </InputLabel>
                    <Select
                      label="Moneda"
                      id="id_moneda"
                      name="id_moneda"
                      value={form.id_moneda || ""}
                      onChange={handleChange}
                      style={{ textTransform: "uppercase" }}
                    >
                      <MenuItem value="" key="">
                        Ninguno
                      </MenuItem>
                      {currencyList.map((item) => (
                        <MenuItem
                          value={item.id}
                          key={item.id}
                          style={{ textTransform: "uppercase" }}
                        >
                          {item.nombre}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <NumberFormat
                    style={{ width: "100%" }}
                    label="Monto asignado"
                    customInput={TextField}
                    value={form?.total_asignado}
                    thousandSeparator={local_separacion_miles}
                    decimalSeparator={local_separacion_decimales}
                    prefix={`${local_simbolo} `}
                    onValueChange={(values) =>
                      handleChangeTotalAsignado(values, "total_asignado")
                    }
                    decimalScale={2}
                  />
                </Grid>

                {parseInt(form.id_moneda) === 4 && (
                  <>
                    {/* <Grid item xs={12} sm={6}></Grid> */}
                    <Grid item xs={12} sm={6}>
                      <NumberFormat
                        style={{ width: "100%" }}
                        label="Valor tipo de cambio"
                        customInput={TextField}
                        value={form?.valor_tipo_cambio}
                        thousandSeparator={local_separacion_miles}
                        decimalSeparator={local_separacion_decimales}
                        prefix={`${local_simbolo} `}
                        onValueChange={(values) =>
                          handleChangeTipoCambio(values, "valor_tipo_cambio")
                        }
                        decimalScale={2}
                      />
                    </Grid>
                  </>
                )}

                <Grid item xs={12}>
                  <div
                    className="d-flex justify-content-start align-items-start"
                    style={{ margin: "0px 0px" }}
                  >
                    <div className="form-check form-switch 'd-flex justify-content-start align-items-center">
                      <input
                        style={{ cursor: "pointer" }}
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="in_flow"
                        name="in_flow"
                        onChange={handleChangeAddFlow}
                        checked={form.in_flow}
                      />
                    </div>
                    <div style={{ fontSize: "13px" }}>Agregar a flujo</div>
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <div style={{ marginTop: "27px", textAlign: "right" }}>
            <Button
              id="id-button-save-ppto"
              className="p-btn-primary"
              variant="contained"
              size="medium"
              type="submit"
            >
              Guardar
            </Button>
          </div>
        </form>
      </div>
    </Dialog>
  );
};
